import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";
import { Box, Container, Table, TableBody, TableCell, TableHead, TableRow, Pagination, TextField, Button, Dialog, DialogTitle, DialogContent, DialogActions, Select, MenuItem, FormControl, InputLabel, FormControlLabel, Switch, Chip, Typography, Divider } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import swal from "sweetalert";
import React from "react";

function GamePresets() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalPresets, setTotalPresets] = useState(0);

    const [gameSearch, setGameSearch] = useState("");
    const [sanhSearch, setSanhSearch] = useState("");
    const [searchedGame, setSearchedGame] = useState("");
    const [searchedSanh, setSearchedSanh] = useState("");

    // Form Modal States
    const [openModal, setOpenModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [formData, setFormData] = useState({
        game: "",
        sanh: "",
        name: "Default",
        strategy_mode: "balanced",
        reverse_streak_threshold: 4,
        follow_streak_threshold: 2,
        min_confidence: 60,
        is_active: true
    });

    const limit = 10;

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    const fetchPresets = () => {
        setLoading(true);
        axios
            .get(
                `${process.env.REACT_APP_API_URL}/statistic/game-presets?page=${page}&limit=${limit}&game=${searchedGame}&sanh=${searchedSanh}`
            )
            .then((res) => {
                setData(res.data.data);
                if (res.data.totalPages) {
                    setTotalPages(res.data.totalPages);
                }
                if (res.data.total !== undefined) {
                    setTotalPresets(res.data.total);
                }
                setLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchPresets();
    }, [page, searchedGame, searchedSanh]);

    const handleSearch = () => {
        setSearchedGame(gameSearch);
        setSearchedSanh(sanhSearch);
        setPage(1);
    };

    const handleReset = () => {
        setGameSearch("");
        setSanhSearch("");
        setSearchedGame("");
        setSearchedSanh("");
        setPage(1);
    };

    const handleChangePage = (e, newPage) => {
        setPage(newPage);
    };

    const handleOpenCreate = () => {
        setIsEdit(false);
        setFormData({
            game: "",
            sanh: "",
            name: "Default",
            strategy_mode: "balanced",
            reverse_streak_threshold: 4,
            follow_streak_threshold: 2,
            min_confidence: 60,
            is_active: true
        });
        setOpenModal(true);
    };

    const handleOpenEdit = (preset) => {
        setIsEdit(true);
        setFormData({
            game: preset.game,
            sanh: preset.sanh,
            name: preset.name || "Default",
            strategy_mode: preset.strategy_mode || "balanced",
            reverse_streak_threshold: preset.reverse_streak_threshold ?? 4,
            follow_streak_threshold: preset.follow_streak_threshold ?? 2,
            min_confidence: preset.min_confidence ?? 60,
            is_active: preset.is_active !== false
        });
        setOpenModal(true);
    };

    const handleSave = () => {
        if (!formData.game || !formData.sanh) {
            swal("Lỗi", "Vui lòng điền đầy đủ Game và Sảnh!", "error");
            return;
        }
        setLoading(true);
        axios
            .post(`${process.env.REACT_APP_API_URL}/statistic/game-preset`, formData)
            .then((res) => {
                swal("Thành công", "Lưu cấu hình sảnh game thành công!", "success");
                setOpenModal(false);
                fetchPresets();
            })
            .catch((err) => {
                swal("Lỗi", err.response?.data?.message || "Không thể lưu cấu hình!", "error");
                setLoading(false);
            });
    };

    const handleDelete = (gameCode, sanhCode) => {
        swal({
            title: "Xác nhận xóa?",
            text: `Bạn có chắc chắn muốn xóa cấu hình game ${gameCode} tại sảnh ${sanhCode}?`,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                setLoading(true);
                axios
                    .delete(`${process.env.REACT_APP_API_URL}/statistic/game-preset?game=${gameCode}&sanh=${sanhCode}`)
                    .then((res) => {
                        swal("Thành công", "Xóa cấu hình thành công!", "success");
                        fetchPresets();
                    })
                    .catch((err) => {
                        swal("Lỗi", err.response?.data?.message || "Không thể xóa cấu hình!", "error");
                        setLoading(false);
                    });
            }
        });
    };

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                <Box component="main" sx={{ flexGrow: 1, py: 1 }}>
                    {loading && (
                        <div className="loading" style={{ maxWidth: "100%" }}>
                            <div className="loader"></div>
                        </div>
                    )}
                    <Container maxWidth={false}>
                        <div className="container_set" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <span>Cấu hình tỉ lệ sảnh (Kill API)</span>
                            <Button
                                variant="contained"
                                onClick={handleOpenCreate}
                                sx={{ backgroundColor: "#2e7d32", "&:hover": { backgroundColor: "#1b5e20" } }}
                            >
                                Thêm cấu hình mới
                            </Button>
                        </div>
                        <div className="form_set">
                            <Box>
                                <div style={{ display: "flex", gap: "15px", flexDirection: "column", width: "100%", marginBottom: "15px" }}>
                                    <div style={{ display: "flex", gap: "15px", alignItems: "center", justifyContent: "flex-start", width: "100%", flexWrap: "wrap" }}>
                                        <TextField
                                            size="small"
                                            value={gameSearch}
                                            onChange={(e) => setGameSearch(e.target.value)}
                                            placeholder="Mã game (ví dụ: xd45s, slots)"
                                            sx={{ minWidth: "220px", "& .MuiInputBase-root": { height: "40px" } }}
                                        />
                                        <TextField
                                            size="small"
                                            value={sanhSearch}
                                            onChange={(e) => setSanhSearch(e.target.value)}
                                            placeholder="Mã sảnh (ví dụ: 140, 86, 1)"
                                            sx={{ minWidth: "180px", "& .MuiInputBase-root": { height: "40px" } }}
                                        />
                                        <Button
                                            variant="contained"
                                            onClick={handleSearch}
                                            sx={{ height: "40px", textTransform: "none", backgroundColor: "#007bff", "&:hover": { backgroundColor: "#0056b3" } }}
                                        >
                                            Tìm kiếm
                                        </Button>
                                        <Button
                                            variant="outlined"
                                            onClick={handleReset}
                                            sx={{ height: "40px", textTransform: "none", borderColor: "#ccc", color: "#333", "&:hover": { borderColor: "#999" } }}
                                        >
                                            Cài lại
                                        </Button>
                                    </div>
                                    <div style={{ display: "flex", justifyContent: "flex-end", fontSize: "14px", color: "#666" }}>
                                        Tổng cộng {totalPresets} bản ghi
                                    </div>
                                </div>

                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ padding: "12px", fontWeight: "bold" }}>Mã sảnh</TableCell>
                                            <TableCell sx={{ padding: "12px", fontWeight: "bold" }}>Mã game</TableCell>
                                            <TableCell sx={{ padding: "12px", fontWeight: "bold" }}>Tên cấu hình</TableCell>
                                            <TableCell sx={{ padding: "12px", fontWeight: "bold" }}>Chiến lược cược</TableCell>
                                            <TableCell sx={{ padding: "12px", fontWeight: "bold" }}>Ngưỡng đảo / thuận</TableCell>
                                            <TableCell sx={{ padding: "12px", fontWeight: "bold" }}>Độ tin cậy (%)</TableCell>
                                            <TableCell sx={{ padding: "12px", fontWeight: "bold" }}>Người cập nhật</TableCell>
                                            <TableCell sx={{ padding: "12px", fontWeight: "bold" }}>Trạng thái</TableCell>
                                            <TableCell sx={{ padding: "12px", fontWeight: "bold" }}>Thao tác</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    {data != null && data.length > 0 ? (
                                        <TableBody>
                                            {data.map((item) => (
                                                <TableRow key={item._id}>
                                                    <TableCell sx={{ padding: "12px", fontWeight: "bold" }}>{item.sanh}</TableCell>
                                                    <TableCell sx={{ padding: "12px", color: "#0288d1", fontWeight: "600" }}>{item.game}</TableCell>
                                                    <TableCell sx={{ padding: "12px" }}>{item.name}</TableCell>
                                                    <TableCell sx={{ padding: "12px" }}>
                                                        {item.strategy_mode === "kill" ? (
                                                            <Chip label="Giết / Ép thua" color="error" size="small" sx={{ fontWeight: "bold" }} />
                                                        ) : item.strategy_mode === "give_win" ? (
                                                            <Chip label="Nhả / Ép thắng" color="success" size="small" sx={{ fontWeight: "bold" }} />
                                                        ) : (
                                                            <Chip label="Cân bằng" color="default" size="small" sx={{ fontWeight: "bold" }} />
                                                        )}
                                                    </TableCell>
                                                    <TableCell sx={{ padding: "12px" }}>
                                                        Đảo: {item.reverse_streak_threshold} | Thuận: {item.follow_streak_threshold}
                                                    </TableCell>
                                                    <TableCell sx={{ padding: "12px", fontWeight: "600" }}>{item.min_confidence}%</TableCell>
                                                    <TableCell sx={{ padding: "12px", fontSize: "12px", color: "#666" }}>
                                                        {item.updated_by_username}
                                                    </TableCell>
                                                    <TableCell sx={{ padding: "12px" }}>
                                                        {item.is_active ? (
                                                            <span style={{ color: "#2e7d32", fontWeight: "bold" }}>Hoạt động</span>
                                                        ) : (
                                                            <span style={{ color: "#c62828", fontWeight: "bold" }}>Tắt</span>
                                                        )}
                                                    </TableCell>
                                                    <TableCell sx={{ padding: "12px" }}>
                                                        <Button
                                                            size="small"
                                                            variant="contained"
                                                            color="primary"
                                                            onClick={() => handleOpenEdit(item)}
                                                            sx={{ mr: 1, textTransform: "none" }}
                                                        >
                                                            Sửa
                                                        </Button>
                                                        <Button
                                                            size="small"
                                                            variant="outlined"
                                                            color="error"
                                                            onClick={() => handleDelete(item.game, item.sanh)}
                                                            sx={{ textTransform: "none" }}
                                                        >
                                                            Xóa
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    ) : (
                                        <TableBody>
                                            <TableRow>
                                                <TableCell colSpan={9} align="center" sx={{ py: 3, color: "#999" }}>
                                                    Không có dữ liệu
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    )}
                                </Table>
                            </Box>
                        </div>
                        <Box sx={{ display: "flex", justifyContent: "center", pt: 3 }}>
                            {data != null && <Pagination color="primary" page={page} count={totalPages} size="small" onChange={handleChangePage} />}
                        </Box>
                    </Container>
                </Box>
            </DashboardLayout>

            <Dialog open={openModal} onClose={() => setOpenModal(false)} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ pb: 1.5, borderBottom: "1px solid #eee", fontWeight: "bold" }}>
                    {isEdit ? "Cập nhật cấu hình sảnh game" : "Thêm cấu hình sảnh game mới"}
                </DialogTitle>
                <DialogContent sx={{ pt: 3 }}>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: "18px" }}>
                        <Box>
                            <Typography variant="caption" sx={{ display: "block", mb: 0.5, fontWeight: "700", color: "text.secondary", textTransform: "uppercase" }}>
                                Mã game
                            </Typography>
                            <TextField
                                value={formData.game}
                                onChange={(e) => setFormData({ ...formData, game: e.target.value })}
                                disabled={isEdit}
                                placeholder="Mã game độc nhất (ví dụ: slots, baccarat, xd45s)"
                                fullWidth
                                size="small"
                            />
                        </Box>
                        
                        <Box>
                            <Typography variant="caption" sx={{ display: "block", mb: 0.5, fontWeight: "700", color: "text.secondary", textTransform: "uppercase" }}>
                                Mã sảnh (product_type)
                            </Typography>
                            <TextField
                                value={formData.sanh}
                                onChange={(e) => setFormData({ ...formData, sanh: e.target.value })}
                                disabled={isEdit}
                                placeholder="Ví dụ: 140 cho JILI, 86 cho EVO, 1 cho Hệ thống"
                                fullWidth
                                size="small"
                            />
                        </Box>

                        <Box>
                            <Typography variant="caption" sx={{ display: "block", mb: 0.5, fontWeight: "700", color: "text.secondary", textTransform: "uppercase" }}>
                                Tên cấu hình
                            </Typography>
                            <TextField
                                value={formData.name}
                                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                placeholder="Tên gợi nhớ (ví dụ: JILI Slots Rate Control)"
                                fullWidth
                                size="small"
                            />
                        </Box>

                        <Box>
                            <Typography variant="caption" sx={{ display: "block", mb: 0.5, fontWeight: "700", color: "text.secondary", textTransform: "uppercase" }}>
                                Chiến lược cược
                            </Typography>
                            <FormControl fullWidth size="small">
                                <Select
                                    value={formData.strategy_mode}
                                    onChange={(e) => setFormData({ ...formData, strategy_mode: e.target.value })}
                                >
                                    <MenuItem value="balanced">Cân bằng (Balanced)</MenuItem>
                                    <MenuItem value="kill">Giết / Ép người chơi thua (Kill)</MenuItem>
                                    <MenuItem value="give_win">Nhả / Ép người chơi thắng (Give Win)</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>

                        <Box sx={{ display: "flex", gap: "15px" }}>
                            <Box sx={{ flex: 1 }}>
                                <Typography variant="caption" sx={{ display: "block", mb: 0.5, fontWeight: "700", color: "text.secondary", textTransform: "uppercase" }}>
                                    Ngưỡng đảo chiều
                                </Typography>
                                <TextField
                                    type="number"
                                    value={formData.reverse_streak_threshold}
                                    onChange={(e) => setFormData({ ...formData, reverse_streak_threshold: Number(e.target.value) })}
                                    fullWidth
                                    size="small"
                                />
                            </Box>
                            <Box sx={{ flex: 1 }}>
                                <Typography variant="caption" sx={{ display: "block", mb: 0.5, fontWeight: "700", color: "text.secondary", textTransform: "uppercase" }}>
                                    Ngưỡng bám cầu
                                </Typography>
                                <TextField
                                    type="number"
                                    value={formData.follow_streak_threshold}
                                    onChange={(e) => setFormData({ ...formData, follow_streak_threshold: Number(e.target.value) })}
                                    fullWidth
                                    size="small"
                                />
                            </Box>
                        </Box>

                        <Box>
                            <Typography variant="caption" sx={{ display: "block", mb: 0.5, fontWeight: "700", color: "text.secondary", textTransform: "uppercase" }}>
                                Độ tin cậy tối thiểu (%)
                            </Typography>
                            <TextField
                                type="number"
                                value={formData.min_confidence}
                                onChange={(e) => setFormData({ ...formData, min_confidence: Number(e.target.value) })}
                                fullWidth
                                size="small"
                            />
                        </Box>

                        <FormControlLabel
                            control={
                                <Switch
                                    checked={formData.is_active}
                                    onChange={(e) => setFormData({ ...formData, is_active: e.target.checked })}
                                    color="success"
                                />
                            }
                            label="Bật hoạt động"
                            sx={{ mt: 1 }}
                        />
                    </Box>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 3, borderTop: "1px solid #eee", pt: 1.5 }}>
                    <Button onClick={() => setOpenModal(false)} variant="outlined" color="inherit">Hủy</Button>
                    <Button onClick={handleSave} color="primary" variant="contained">Lưu cấu hình</Button>
                </DialogActions>
            </Dialog>
        </ThemeProvider>
    );
}

export default GamePresets;
